<ng-container [formGroup]="parent">
  <!-- <ng-container formGroupName="shipTo">
    <h2 class="mb-4">Ship To</h2>
    <div class="form-group has-float-label mb-4">
      <div class="form-group has-float-label">
        <ng-select
          class="p-0"
          formControlName="addressSelectionName"
          (change)="onDeliveryAddressChange($event)"
          [ngClass]="{
            'has-error': formErrors.addressSelectionName
          }"
          (blur)="logValidationErrors()"
        >
          <ng-option
            *ngFor="let com of deliveryAddress"
            [value]="com.name"
            [disabled]="com.status"
          >
            {{ com.name }}
          </ng-option>
        </ng-select>
        <label class="form-label">Delivery Address<span class="madatory-field">*</span></label>
        <span class="error-msg" *ngIf="formErrors.addressSelectionName">
          {{ formErrors.addressSelectionName }}
        </span>
      </div>
    </div>
    <div class="ship-address" ngbDropdown #shipaddress="ngbDropdown">
      <div
        class="form-group has-float-label mb-4"
        *ngIf="shipToAddress"
        id="dropdownBasic2"
      >
        <input
          jniAutoCompleteBlocker
          type="text"
          class="form-control"
          placeholder=""
          [value]="shiftToAddressField"
          (click)="onshipToAddressFilter($event, shipaddress)"
        />
        <label class="form-label">Client Ship To Name</label>
      </div>
      <div
        class="order-dropdown"
        ngbDropdownMenu
        aria-labelledby="dropdownBasic2"
      >
        <ng-scrollbar style="height: 200px">
          <p-table
            #dt
            [value]="customerList"
            styleClass="p-datatable-customers order-listing"
            [rowHover]="true"
            [rows]="10"
            [showCurrentPageReport]="true"
            [rowsPerPageOptions]="[10, 25, 50]"
            [paginator]="false"
            [filterDelay]="0"
          >
            <ng-template pTemplate="header">
              <tr>
                <th class="name">Name and Description</th>
                <th class="name">Address</th>
                <th class="vaccount">Street</th>
                <th class="sname">Purpose</th>
              </tr>
            </ng-template>
            <ng-template
              pTemplate="body"
              let-shiftToAddressLists
              let-rowIndex="rowIndex"
            >
              <tr
                class="p-selectable-row mousepointer"
                (click)="
                  onShitToAddressSeletion(shiftToAddressLists, shipaddress)
                "
              >
                <td class="name mousepointer">
                  {{ shiftToAddressLists.descriptionD365 }}
                </td>
                <td class="name mousepointer">
                  {{ shiftToAddressLists.addressD365 }}
                </td>
                <td class="vaccount mousepointer">
                  {{ shiftToAddressLists.streetD365 }}
                </td>
                <td class="sname mousepointer">
                  {{ shiftToAddressLists.rolesD365 }}
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="20">No address found.</td>
              </tr>
            </ng-template>
          </p-table>
        </ng-scrollbar>
      </div>
    </div>
    <div class="v-account" ngbDropdown #vendoracount="ngbDropdown">
      <div
        class="form-group has-float-label mb-4"
        *ngIf="vendorAccountAndBook"
        id="dropdownBasic5"
      >
        <input
          jniAutoCompleteBlocker
          type="text"
          class="form-control"
          placeholder=""
          formControlName="shipToVendorAccountNameD365"
          [value]="vendorAccountSeletion"
          (input)="searchVendor$.next($any($event.target).value)"
          (keypress)="onVendorSearchOpenToggle(vendoracount)"
        />
        <label class="form-label">Vendor Account</label>
      </div>
      <div
        class="order-dropdown max-width-600"
        ngbDropdownMenu
        aria-labelledby="dropdownBasic5"
      >
        <ng-scrollbar style="height: 200px">
          <p-table
            #dt
            [value]="vendorList"
            styleClass="p-datatable-customers order-listing"
            [rowHover]="true"
            [rows]="10"
            [showCurrentPageReport]="true"
            [rowsPerPageOptions]="[10, 25, 50]"
            [paginator]="false"
            [filterDelay]="0"
          >
            <ng-template pTemplate="header">
              <tr>
                <th class="name">Name</th>
                <th class="vaccount">Vendor Account</th>
                <th class="sname">Search name</th>
                <th class="phone">Phone</th>
                <th class="city">City</th>
                <th class="state">State</th>
                <th class="country">Country</th>
              </tr>
            </ng-template>
            <ng-template
              pTemplate="body"
              let-vendorList
              let-rowIndex="rowIndex"
            >
              <tr
                class="p-selectable-row mousepointer"
                (click)="onVendorAccountSelection(vendorList, vendoracount)"
              >
                <td class="name mousepointer">
                  {{ vendorList.vendorName }}
                </td>
                <td class="vaccount mousepointer">
                  {{ vendorList.vendorAccountNumber }}
                </td>
                <td class="sname mousepointer">
                  {{ vendorList.vendorSearchName }}
                </td>
                <td class="phone mousepointer">
                  {{ vendorList.phoneNumber }}
                </td>
                <td class="city mousepointer">{{ vendorList.city }}</td>
                <td class="state mousepointer">{{ vendorList.state }}</td>
                <td class="country mousepointer">
                  {{ vendorList.country }}
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="20">No address found.</td>
              </tr>
            </ng-template>
          </p-table>
        </ng-scrollbar>
      </div>
    </div>
    <div ngbDropdown #vendoraddressbook="ngbDropdown">
      <div
        class="form-group has-float-label mb-4"
        *ngIf="vendorAccountAndBook"
        id="dropdownBasic6"
      >
        <input
          jniAutoCompleteBlocker
          type="text"
          class="form-control"
          placeholder=""
          [value]="addressBookName"
          (click)="onVendorAddressBookSelect(vendoraddressbook)"
        />
        <label class="form-label">Vendor Ship To Name</label>
      </div>
      <div
        class="order-dropdown"
        ngbDropdownMenu
        aria-labelledby="dropdownBasic6"
      >
        <p-table
          #dt
          [value]="addressBookList"
          styleClass="p-datatable-customers order-listing"
          [rowHover]="true"
          [rows]="10"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 25, 50]"
          [paginator]="false"
          [filterDelay]="0"
        >
          <ng-template pTemplate="header">
            <tr>
              <th class="name">Name or description</th>
              <th class="vaccount">Address</th>
              <th class="sname">Primary</th>
              <th class="sname">Purpose</th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-addressBookLists
            let-rowIndex="rowIndex"
          >
            <tr
              class="p-selectable-row mousepointer"
              (click)="
                onVendorAddressBookSelection(
                  addressBookLists,
                  vendoraddressbook
                )
              "
            >
              <td class="vaccount mousepointer">
                {{ addressBookLists.descriptionD365 }}
              </td>
              <td class="vaccount mousepointer">
                {{ addressBookLists.addressD365 }}
              </td>
              <td class="vaccount mousepointer">
                {{ addressBookLists.isPrimaryD365 }}
              </td>
              <td class="sname mousepointer">
                {{ addressBookLists.rolesD365 }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No address found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="form-group has-float-label mb-4">
      <input
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        placeholder=""
        formControlName="attention"
      />
      <label class="form-label">Attention</label>
    </div>
    <div class="form-group has-float-label mb-4">
      <input
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        placeholder=""
        formControlName="locationD365"
      />
      <label class="form-label">Location</label>
    </div>
    <div class="form-group has-float-label mb-4" [hidden]="!showAddress">
      <textarea
        jniAutoCompleteBlocker
        placeholder=""
        class="form-control"
        formControlName="addressD365"
      ></textarea>
      <label class="form-label">Address</label>
    </div>
    <jni-address
      *ngIf="showAddressComponent()"
      [parent]="parent"
      [cityList]="cityList"
      [countryRegionList]="countryRegionList"
      [countyList]="countyList"
      [districtList]="districtList"
      [formgroupName]="'shipTo'"
      [hiddenHeadingStatus]="true"
    >
    </jni-address>
    <div class="form-group has-float-label mb-4 mt-3">
      <input
        jniAutoCompleteBlocker
        type="email"
        class="form-control"
        placeholder=""
        formControlName="rSMJNIShipToEmailD365"
      />
      <label class="form-label">Ship to email</label>
    </div>
  </ng-container>
   -->
  <jni-ship-to-address
    #shipTo
    [parent]="parent"
    [deliveryAddress]="deliveryAddress"
    [countryRegionList]="countryRegionList"
    (smallLoaderEvent)="getLoaderStatus($event)"
    [showAddress]="showAddress"
    [shiftToAddressList]="customerList"
    [formgroupName]="'shipTo'"
    [formErrors]="formErrors"
    (validationErrorEvent)="logValidationErrors()"
    [shipToAddress]="shipToAddress"
    [vendorAccountAndBook]="vendorAccountAndBook"
    [addressObject]="addressObject"
    [headerObject]="headerObject"
    [clientShipToAddressDisabled]="clientShipToAddressDisabled"
    [vendorNameShipToAddressDisabled]="vendorNameShipToAddressDisabled"
    (multiShipToAndTbdEvent)="patchValueInMultiShipToAndTbd($event)"
    [isEditFromCdi]="isEditFromCdi"
    (melissaValidationIgnoreEvent)="handleMelissaValidationIgnore($event)"
    (melissaAddressValidatedEvent)="melissaAddressValidatedEvent($event)"
    [isShipToAddressFromOrder]="true"
    [fromAddressAssignment]="fromAddressAssignment"
    [defaultOneTime]="defaultOneTime"
    [isShipToAddresssFromOrderLines]="isShipToAddresssFromOrderLines"
    [lineStatusD365]="lineStatusD365"
    [collapseStatus]="collapseStatus">
  </jni-ship-to-address>
</ng-container>
